import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import GroupSelect from '../../../../containers/groups/select/GroupSelect'

const GeneralSection = () => {
  const { t } = useTranslation('screens')
  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('name')} field="name" />
      </Col>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('userGroups')} field={'userGroups'} Input={GroupSelect} multiple />
      </Col>
    </Grid>
  )
}

export default GeneralSection
